module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./SkCarRankingView.js"));
	}, "SkCarRankingView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=SkCarRankingView!./src/pages/Shop/Home/SkCarRanking/SkCarRankingView.js
// module id = 1426
// module chunks = 418